// i18n area 'apps' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.lt-LT.meta.json.
import type { enUS } from './apps'

export const ltLT: typeof enUS = {

  // Apps 1 banga (Annex R): valdomi podman konteineriai — prižiūrimi worker
  // deklaruotame mazge; atvaizdis = branch@digest lockfile (Annex Q) su
  // pinned/tracking politika; untagged L3 prijungimas su statiniu IP.
  apps: {
    title: 'App',
    create: 'Sukurti App',
    createTitle: 'Sukurti App',
    editTitle: 'Redaguoti App',
    name: 'Pavadinimas',
    nameHint: 'DNS-1123, unikalus scope viduje — po sukūrimo nekeičiamas.',
    node: 'Mazgas',
    nodeHint: 'Ją aptarnaujantis mazgas narys — aiškiai nurodomas išdėstymas (planuoklis bus vėliau).',
    image: 'Atvaizdis',
    editImageHint: 'Nauja nuoroda iš naujo išsprendžiama per kartoteką — prisegimo / rollback veiksmas.',
    imagePolicy: 'Politika',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest keičiasi tik pagal komandą.',
    policyTrackingHint: 'Automatinis rolling, kai atnaujinimas perkelia branch.',
    archMovePolicy: 'Cross-arch perkėlimas',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Kas nutinka, jei app perkeliama į kitos architektūros mazgą: refuse atmeta perkėlimą, reresolve iš naujo išsprendžia lockfile iš branch naujoje arch — turinys pasikeičia, ir atsakymas įvardija digest pasikeitimą.',
    network: 'Tinklas',
    networkHint: 'Untagged L3 prijungimas: loginis fabric tinklas (rekomenduojama — šliuzas ir DNS iš jo vienintelio šaltinio), overlay arba grynas hosto bridge (nerekomenduojama).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'hosto bridge:',
    ipAssignment: 'IP priskyrimas',
    ipStatic: 'Statinis',
    ipAuto: 'Automatinis (IPAM)',
    ipAssignmentHint_static: 'Adresą nurodote dabar patys.',
    ipAssignmentHint_auto: 'IPAM parenka laisvą adresą iš tinkle TVirt rezervuotų diapazonų.',
    bridgeDiscouraged: 'Grynas hosto bridge — NEREKOMENDUOJAMA: TVirt nieko nežino apie jo adresavimą, todėl šliuzą ir DNS tenka nurodyti ranka. Rekomenduojamas kelias — loginis fabric tinklas.',
    ip: 'IP',
    ipHint: 'Statinis IPv4 prijungimo potinklyje.',
    ipCidrHint: 'CIDR forma ant gryno bridge (pvz., 192.168.1.10/24) — nėra iš ko išvesti prefikso.',
    gateway: 'Šliuzas',
    gatewayManualHint: 'Rankinis — grynas bridge nieko neišveda.',
    dnsServers: 'DNS serveriai',
    dnsManualHint: 'Rankiniai, atskirti kableliais — bent vienas.',
    rootKind: 'Root',
    rootEphemeral: 'efemerinis',
    rootPersistent: 'nuolatinis',
    rootEphemeralHint: 'Kaskart perkuriant atkuriamas iš atvaizdžio; laikomas klasterio efemeriniame storage.',
    rootEphemeralHintNamed: 'Kaskart perkuriant atkuriamas iš atvaizdžio; laikomas klasterio efemeriniame storage ({name}).',
    rootPersistentHint: 'Išlieka po paleidimų iš naujo; laikomas jūsų pasirinktame storage.',
    rootStorage: 'Root storage',
    editRootStorageHint: 'Root perkuriamas naujame telkinyje — esami duomenys patys NEPERSIKELIA.',
    volumes: 'Tomai',
    volumeAdd: 'Pridėti tomą',
    volumeName: 'Pavadinimas',
    volumeMountPath: 'Prijungimo kelias',
    volumeKind: 'Tipas',
    volumeStorage: 'Storage',
    devices: 'Įrenginiai',
    deviceClassHint: 'Prašoma KLASĖS (gpu-device arba usb-device žymos), niekada konkretaus įrenginio: nurodytas mazgas turi turėti tokį, pažymėtą programėlėms. Kelios programėlės gali naudoti tą patį įrenginį — konteineris jį dalijasi, neatima jo iš pagrindinio kompiuterio.',
    deviceSlot: 'Lizdas',
    deviceTag: 'Žyma',
    deviceValue: 'Klasė',
    deviceUnresolved: 'dabar nieko neišsprendžiama',
    noDeviceTags: 'Kol kas nėra gpu-device ar usb-device rūšies žymos: sukurk ją ir priskirk programėlėms pažymėtiems įrenginiams.',
    env: 'Aplinka',
    envHint: 'Po vieną RAKTAS=reikšmė kiekvienoje eilutėje.',
    secretEnvTitle: 'Slaptieji kintamieji',
    secretEnvNotice: 'Slapta reikšmė iš API niekada nebegrįžta: niekas jos nebeperskaito, net tas, kas ją įrašė. Checkpoint viduje ji keliauja užantspauduota masterpass, todėl atkūrimas be masterpass paprašys ją įrašyti iš naujo.',
    secretEnvPromote: 'Padarykite slaptą vieną iš aukščiau įrašytų kintamųjų:',
    secretEnvAdd: 'Pridėti slaptą kintamąjį',
    secretEnvName: 'Pavadinimas',
    secretEnvValue: 'Reikšmė',
    secretEnvKept: 'išsaugota — palikite tuščią, kad nepasikeistų',
    secretEnvWithdrawWarning: 'Kad nustotumėte laikyti slaptu kintamąjį, kuris jau toks yra, įrašykite jam naują reikšmę: vien žymos nuėmimas būtų būdas PERSKAITYTI tai, kas iš store niekada neišeina. O kintamojo pašalinimas jį ištrina.',
    secretEnvChip: 'slapta',
    startNow: 'Paleisti iš karto (kitaip App sukuriama sustabdyta)',
    deletePersistentIntro: 'Ši App turi nuolatinių duomenų — pasirinkite, ką su jais daryti:',
    deleteKeepData: 'Palikti duomenis (katalogai lieka savo storage kaip našlaičiai)',
    deletePurgeData: 'Šalinti ir duomenis',
    phase: 'Fazė',
    phase_running: 'Veikia',
    phase_stopped: 'Sustabdyta',
    phase_error: 'Klaida',
    phase_unknown: 'Nežinoma',
    desiredState: 'Pageidaujama',
    wantedRunning: 'veikia',
    wantedStopped: 'sustabdyta',
    start: 'Paleisti',
    stop: 'Stabdyti',
    restart: 'Paleisti iš naujo',
    refreshImage: 'Atnaujinti atvaizdį (perimti naują @current)',
    logs: 'Žurnalas',
    logsTitle: 'Žurnalas',
    logsEmpty: 'Išvesties neužfiksuota.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App neveikia — shell reikia gyvo konteinerio. Jos žurnalus galima skaityti bet kurioje būsenoje.',
    shellConnect: 'Prisijungti',
    shellDisconnect: 'Atsijungti',
    shellExited: 'Sesija baigėsi išėjimo kodu {code}.',
    shellEndedWithoutStatus: 'Sesija baigėsi be išėjimo būsenos: {reason}',
    shellRevoked: 'Sesijos ticket nebegalioja — jis pasibaigė arba jį atidaręs prisijungimas buvo atšauktas.',
    shellHint: 'Spustelėkite juodą lauką ir rašykite: klavišai pasiekia konteinerį. Ctrl+C ir rodyklės veikia; exit uždaro shell.',
    shellStatus: {
      connecting: 'Jungiamasi…',
      connected: 'Prisijungta',
      ended: 'Baigta'
    },
    deleteRunningError: '{name} pageidaujama veikianti — pirma ją sustabdykite.',

    // Standartinis dialogas (round #156): išsamios peržiūros kortelės ir
    // trūkstami contract laukai — matomas kiekvienas App laukas, spynos su priežastimi.
    tabs: {
      general: 'Bendra',
      image: 'Atvaizdis',
      network: 'Tinklas',
      storage: 'Storage',
      devices: 'Įrenginiai',
      observed: 'Stebima'
    },
    attachment: 'Prijungimas',
    runningDigest: 'Veikiantis digest',
    lastError: 'Paskutinė klaida',
    reportObservedAt: 'Paskutinis worker pranešimas',
    desiredStateLock: 'Valdo veiksmai Paleisti ir Stabdyti — niekada ne tiesioginis redagavimas.',
    ipEditDisabledHint: 'Redaguojama tik esant statiniam priskyrimui.',
    derivedFromNetworkHint: 'Išvedama iš vienintelio tinklo šaltinio — rankiniu būdu tik ant gryno bridge su statiniu IP.',
    ephemeralUnset: 'nesukonfigūruota',
    ephemeralMissing: 'App efemerinis storage nesukonfigūruotas — App su efemerinėmis dalimis (root ar tomais) kūrimas atmetamas, kol jo nenustatysite.',
    ephemeralCurrent: 'App efemerinis storage: {name}',
    ephemeralMissingCreate: 'Ši App turi efemerinių dalių, bet klasterio App efemerinis storage nenustatytas — kūrimas bus atmestas. Pirma nustatykite jį App puslapio pranešimų juostoje.',
    setEphemeral: 'Nustatyti efemerinį storage',
    changeEphemeral: 'Keisti efemerinį storage',
    setEphemeralTitle: 'Nustatyti App efemerinį storage',
    changeEphemeralTitle: 'Keisti App efemerinį storage',
    ephemeralStorageHint: 'Klasterio NUMATYTASIS: dir tipo telkinys, kuriame laikomos visų App efemerinės root ir efemeriniai tomai, nebent App skelbia savo override. Keitimas nėra karštas ir nieko neperkrauna: galioja nuo kito kiekvienos App paleidimo — efemeriniai duomenys neperkeliami.',
    ephemeralPool: 'Storage telkinys',
    ephemeralOverride: 'Efemerinis storage (atskiros App override)',
    ephemeralOverrideInherit: 'Paveldėti klasterio numatytąjį',
    ephemeralOverrideInheritNamed: 'Paveldėti klasterio numatytąjį ({name})',
    ephemeralOverrideHint: 'Atskiros App telkinys efemerinei root ir tomams — palikite tuščią, kad būtų paveldėtas klasterio numatytasis. Keitimas nėra karštas ir nieko neperkrauna: galioja nuo kito paleidimo (efemeriniai duomenys atgimsta tušti naujame telkinyje) ir reikalauja app.ephemeralStorage.set teisės.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Visos šakos',
    imageBranchHint: 'Susiaurina atvaizdus iki tų, kuriuos įvardija ši šaka; be šakos matomi visi saugyklos atvaizdai.',
    imageDigestHint: 'Turinys: renkamasi iš digestų lentelės, kuri nurodo jo kilmę ir architektūrą. Ta pati šaka siūlo po vieną kiekvienai architektūrai, ir jie nėra tarpusavyje pakeičiami.',
    imageLockfile: 'Išspręsta nuoroda',
    imageNoImages: 'Šiai saugyklai podėlyje atvaizdų nėra — atsisiųsk vieną iš OCI atvaizdų.',
    imageHeadNotCached: 'nėra podėlyje — atsisiunčiama paleidžiant',
    imageNoRegistries: 'Neužregistruota nė viena saugykla: užregistruok vieną, kad galėtum pasirinkti atvaizdą.',
    imageChosenHint: 'Atvaizdas renkamas redagavimo dialogo kaskadoje: nuoroda niekada nerašoma ranka.',
    registerRepositoryHint: 'Registravimas nieko neatsiunčia: jis padaro saugyklą stebimą, kad atvaizdą būtų galima pasirinkti neišeinant iš šio dialogo.',
    registerRepositoryBranchHint: 'Neprivaloma: pirmoji stebima šaka (pvz., latest).',
    registerRepositoryElsewhere: 'Ieškoma saugykla neužregistruota: registravimas vyksta OCI atvaizdų skiltyje, jį atlieka turintysis leidimą.'
  },

  // CT template (round K2 #63): MATERIALIZUOTI CT objektai — importas iš
  // katalogo yra vienintelis įėjimas; failai įkeliami į katalogus.
  cts: {
    createAction: 'Sukurti CT',
    createTitle: 'Sukurti konteinerį iš template',
    createError: 'Konteineris nebuvo sukurtas',
    template: 'CT template',
    noTemplates: 'Nėra nė vieno CT template — importuokite jį skiltyje CT template',
    resources: 'Ištekliai',
    node: 'Mazgas',
    phase: {
      defined: 'Niekada nepaleistas',
      materializing: 'Materializuojamas',
      ready: 'Parengtas',
      starting: 'Paleidžiamas',
      running: 'Veikia',
      stopping: 'Stabdomas',
      stopped: 'Sustabdytas',
      deleting: 'Šalinamas',
      error: 'Klaida'
    },
    actions: {
      start: 'Paleisti',
      stop: 'Stabdyti',
      restart: 'Paleisti iš naujo',
      markTemplate: 'Paaukštinti į CT template',
      error: 'Veiksmas buvo atmestas'
    },
    markTemplate: {
      confirmTitle: "Paaukštinti '{name}' į CT template?",
      confirmBody: 'Konteineris palieka šį sąrašą ir atsiduria tarp CT template, iškart pasirengęs kurti naujus CT. Jo metaduomenys lieka redaguojami, o grąžinti jį į CT galima bet kada.',
      confirm: 'Paaukštinti',
      moved: "'{name}' dabar yra CT template — rasite jį skiltyje CT template."
    },
    stopCause: {
      api: 'Sustabdytas per TVirt',
      'ct-exit': 'Konteineris išsijungė pats',
      'host-reboot': 'Nutrūko perkraunant mazgą',
      'start-failed': 'Paleisti nepavyko — task klaida nurodo, ko trūksta ir kaip tai sutvarkyti'
    },

    console: 'Konsolė',
    consoleUnavailable: 'Konteineris neveikia — konsolei reikia gyvo konteinerio. Jo žurnalą tuo tarpu galima skaityti bet kokios būsenos.',
    consoleNoTemplate: 'Template niekada neveikia, todėl neturi konsolės: sukurkite iš jo CT ir atverkite jo konsolę.',
    consoleConnect: 'Prisijungti',
    consoleDisconnect: 'Atsijungti',
    consoleReconnect: 'Jungtis iš naujo',
    consoleTakenBy: 'Šią konsolę užėmė kitas operatorius ({user}). Viena konsolė vienam konteineriui: prisijungus iš naujo ji vėl jūsų.',
    consoleHint: 'Spustelėkite juodą sritį ir rašykite: klavišai pasiekia konteinerį. Ctrl+C ir rodyklės veikia.',
    consoleEndpointDown: 'Konsolės prieigos taško nepavyksta atverti mazge, kuris aptarnauja container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container neveikia — shell reikia gyvo container. Jo logus galima skaityti bet kurioje būsenoje.',
    shellNoTemplate: 'Template niekada neveikia, todėl shell neturi: sukurkite iš jo CT ir atverkite jo shell.',
    shellConnect: 'Prisijungti',
    shellDisconnect: 'Atsijungti',
    shellExited: 'Sesija baigėsi išėjimo kodu {code}.',
    shellEndedWithoutStatus: 'Sesija baigėsi be išėjimo būsenos: {reason}',
    shellRevoked: 'Sesijos ticket nebegalioja — jis pasibaigė arba jį atidaręs prisijungimas buvo atšauktas.',
    shellHint: 'Spustelėkite juodą lauką ir rašykite: klavišai pasiekia konteinerį. Ctrl+C ir rodyklės veikia; exit uždaro shell.',
    shellStatus: {
      connecting: 'Jungiamasi…',
      connected: 'Prisijungta',
      ended: 'Baigta'
    },
    rootPassword: 'Root slaptažodis',
    rootPasswordHint: 'Įrašomas vieną kartą į nukopijuotą rootfs (kaip hash, daugiau nerodomas). Distribucijų image root slaptažodžio neturi: be jo shell yra vienintelis įėjimas.',
    sshKeys: 'Vieši root SSH raktai',
    sshKeysHint: 'Po vieną viešą OpenSSH raktą eilutėje, į root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Jungiamasi…',
      connected: 'Prisijungta',
      reconnecting: 'Jungiamasi iš naujo…'
    },
    logs: 'Žurnalas',
    logsTitle: 'Žurnalas',
    logsEmpty: 'Išvesties neužfiksuota.',
    logsSource: 'Kuris žurnalas',
    logsSourceConsole: 'Konteinerio init konsolė — kodėl viduje esanti paslauga nepasileido',
    logsSourceSupervisor: 'liblxc prižiūrėtojas — kodėl konteineris net nepradėjo veikti',
    logsNeverStarted: 'Jis niekada nebuvo paleistas, todėl dar nieko neužrašyta — paleiskite jį, ir žurnalas bus net jei paleisti nepavyks.',
    logsNoTemplate: 'Template niekada neveikia, todėl nieko niekada neužrašė.',
    logsError: 'Žurnalo nepavyko užfiksuoti',

    // Standartinis dialogas (round #156): išsamios peržiūros kortelės, bendros
    // CT ir CT template sąrašams, ir spynos su priežastimi.
    tabs: {
      general: 'Bendra',
      hardware: 'Aparatinė įranga',
      network: 'Tinklas',
      provenance: 'Kilmė'
    },
    templateFlag: 'CT template',
    templateLock: 'Keičiama tik veiksmais Paaukštinti ir Grąžinti į CT — niekada ne tiesioginis redagavimas.',
    sourceLock: 'Kilmė, užrašyta gimimo metu — niekada neperrašoma; dingęs šaltinis palieka plikąją nuorodą.',
    storageLock: 'Nustatoma kuriant — rootfs perkėlimas numatytas būsimame etape.',
    startedAt: 'Paleistas',
    lastStop: 'Paskutinis sustabdymas',
    editNicsTitle: 'Redaguoti tinklus',
    nicDisconnected: 'atjungta'
  },
  ctTemplates: {
    title: 'CT template',
    importAction: 'Importuoti iš katalogo',
    importTitle: 'Importuoti CT template iš katalogo',
    importSubmit: 'Importuoti',
    importError: 'Importas buvo atmestas',
    importHint: 'Materializavimas nukopijuoja rootfs į pasirinktą storage — katalogo failas lieka nepaliestas. Kad pridėtumėte naujų failų, pirma įkelkite juos į katalogą.',
    sourceFile: 'CT template failas',
    sourceFileHint: 'Pasirinkto katalogo ct-rootfs failai, tik parengti',
    noFiles: 'Šiame kataloge nėra parengto ct-rootfs failo — įkelkite jį katalogo puslapyje',
    source: 'Šaltinio failas',
    rootfsStorage: 'Rootfs storage',
    rootfsStorageHint: "Kur laikomas išskleistas rootfs medis — storage su failų sistema ir pakankamai laisvos vietos išskleistam dydžiui ir dar maždaug 1 GiB atsargai (kitaip importas nepavyks).",
    resources: 'Ištekliai',
    cores: 'vCPU',
    memoryMiB: 'Atmintis (MiB)',
    cpuLimit: 'CPU riba',
    cpuLimitHint: 'Hosto branduolių ekvivalentai (pvz., 1.5); tuščia = be ribos',
    cpuUncapped: 'be ribos',
    cpuWeight: 'CPU svoris',
    hostname: 'Hostname',
    hostnameHint: 'Tuščia = paties CT pavadinimas',
    nameservers: 'DNS vardų serveriai',
    dnsHint: 'Atskirti kableliais; tuščia = paveldėti hosto',
    searchDomains: 'DNS paieškos domenai',
    dnsInherited: 'Paveldėta iš hosto',
    networks: 'Tinklai',
    nicSlot: 'NIC lizdas',
    phase: {
      materializing: 'Materializuojamas',
      ready: 'Parengtas',
      deleting: 'Šalinamas',
      error: 'Klaida'
    },
    exportAction: 'Eksportuoti į katalogą',
    exportTitle: 'Eksportuoti į katalogą',
    exportSubmit: 'Eksportuoti',
    exportError: 'Eksportas buvo atmestas',
    exportHint: 'Supakuoja materializuotą rootfs į NAUJĄ ct-rootfs failą pasirinktame kataloge — template lieka nepaliestas.',
    exportName: 'Failo pavadinimas',
    exportNameHint: 'Tuščia = <template>-export-<n>',
    markCt: {
      action: 'Grąžinti į CT',
      confirmTitle: "Grąžinti '{name}' į CT?",
      confirmBody: 'Template palieka šį sąrašą ir grįžta į CT sąrašą, vėl paleidžiamas. Kol jo vėl nepaaukštinsite, iš jo naujų CT sukurti negalima.',
      confirm: 'Grąžinti į CT',
      moved: "'{name}' vėl yra paprastas CT — rasite jį CT sąraše."
    }
  },

  // OCI 1 banga (Annex Q — žyma kaip branch modelis): OCI žyma yra branch
  // (judanti rodyklė), digest yra commit; atnaujinimas = "git fetch",
  // pull = išspręsk DABAR, atsisiųsk TĄ digest.
  oci: {
    registriesTitle: 'OCI registry',
    imagesTitle: 'OCI atvaizdžiai',
    provider: 'Tiekėjas',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Bendrinis',
    providerImmutableHint: 'Tiekėjas po sukūrimo nekeičiamas — kitas tiekėjas yra naujas registry.',
    url: 'URL',
    urlHintPreset: 'Užpildyta pagal tiekėją — keiskite tik dėl veidrodinių serverių.',
    urlHintRequired: 'Privaloma bendriniams registry: bazinis https:// URL.',
    urlHintEcr: 'Privaloma: ECR galiniai taškai yra pagal paskyrą ir regioną — išankstinės reikšmės nėra.',
    credential: 'Prisijungimo duomenys',
    credentialNone: 'Anoniminė prieiga',
    credentialHint: 'Keystore įrašas su naudotoju ir slaptažodžiu; worker jį išsprendžia naudojimo metu — jokių auth failų kiekviename mazge.',
    nameHint: 'Hosto tipo pavadinimas (docker.io, registry.intra); unikalus scope viduje, nekeičiamas',
    addRegistry: 'Pridėti registry',
    addRegistryTitle: 'Pridėti OCI registry',
    verify: 'Patikrinti',
    verifyState: 'Patikra',
    verified: 'Patikrinta',
    verifyFailed: 'Nepavyko',
    neverVerified: 'Niekada netikrinta',
    registryInUseError: "'{name}' vis dar turi registruotų repozitorijų — pirma jas pašalinkite.",
    repositories: 'Repozitorijos',
    repositoriesHint: 'Registruojant tik stebimi branch (OCI žymos) — nieko neatsisiunčiama. Atnaujinimas išsprendžia kiekvieną stebimą branch ir kaupia reflog.',
    noRepositories: 'Šiame registry neregistruota nė viena repozitorija.',
    registerRepository: 'Registruoti repozitoriją',
    repoPath: 'Kelias',
    repoPathHint: "Repozitorijos kelias registry, pvz., 'example' arba 'library/nginx'",
    branches: 'Branch',
    branchesHint: 'Stebimi branch (OCI žymos), atskirti kableliais — pvz., 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Išsprendžiama DABAR: pull atsisiunčia digest, į kurį branch rodo šiandien.',
    refresh: 'Atnaujinti',
    deleteRepository: 'Šalinti repozitoriją',
    reflogCount: 'ankstesnių: {n}',
    noResolutions: 'Niekada neatnaujinta — nepastebėta nė vieno išsprendimo.',
    refreshFailed: 'Paskutinis atnaujinimas nepavyko ({when})',
    loadError: 'Nepavyko įkelti repozitorijų.',
    reference: 'Nuoroda',
    digest: 'Digest',
    digestHint: 'sha256:… — tikslus atvaizdis, be branch (detached)',
    size: 'Dydis',
    nodes: 'Mazgai',
    detached: 'detached',
    detachedHint: 'Atsisiųsta pagal digest, be branch — drift patikra netaikoma.',
    pulledAt: 'Atsisiųsta',
    pull: 'Pull',
    pullTitle: 'Atvaizdžio pull',
    pullHint: 'Išankstinis parengimas, niekada ne būtina sąlyga: pull pagal branch išsprendžia DABAR ir atsisiunčia TĄ digest; pull pagal digest yra detached.',
    pullError: 'Pull buvo atmestas',
    pullMode: 'Pull pagal',
    pullModeBranch: 'Branch (išspręsti dabar)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Sąžiningas numatytasis: kaip apt install — vėliau pakartotas gali duoti kitą atvaizdį.',
    pullModeDigestHint: 'Tikslus digest — atkuriamumas ir rollback; atsisakoma drift patikros.',

    // Dviejų mygtukų šablonas (#88, ratifikuota 2026-07-30 vakare): "iš
    // registry" yra esamas vedamas pull, "iš katalogo" materializuoja
    // parengtą oci-image archyvą (air-gapped kelias).
    importFromRegistry: 'Importuoti iš registry',
    importFromCatalog: 'Importuoti iš katalogo',
    importCatalogTitle: 'Importuoti OCI atvaizdį iš katalogo',
    importCatalogHint: 'Air-gapped kelias: parengtas oci-image archyvas (tar/tar.gz — docker-archive arba oci-archive) materializuojamas atvaizdžių saugykloje su nuoroda catalog/<katalogas>/<failas>@<digest>; App jį naudoja kaip bet kurį kitą atvaizdį. Archyvai įkeliami į katalogus — ši skiltis tik importuoja.',
    importCatalogFile: 'Archyvas',
    importCatalogFileHint: 'Parengti pasirinkto katalogo oci-image failai.',
    importCatalogNoFiles: 'Šiame kataloge nėra parengto oci-image archyvo — įkelkite jį iš katalogo išsamaus rodinio.',
    importCatalogError: 'Importas buvo atmestas',
    registry: 'Registry',
    repository: 'Repozitorija',
    cacheMissing: 'Klasterio OCI podėlis nesukonfigūruotas — pull atmetami, kol nenustatysite storage telkinio.',
    setCache: 'Nustatyti podėlį',
    setCacheTitle: 'Konfigūruoti OCI podėlį',
    setCacheHint: 'Klasterio lygmens NUMATYTASIS telkinys, kuriame laikomi atsisiųstų atvaizdžių blobai — scope gali jį pakeisti savo telkiniu (Scope puslapis). Keitimas nėra karštas ir nieko neperkrauna, taip pat neperkelia blobų: jie tingiai atsiranda kito paleidimo ar panaudojimo metu.',
    cachePool: 'Storage telkinys',
    changeCache: 'Keisti podėlį',
    changeCacheTitle: 'Keisti OCI podėlio telkinį',
    cacheCurrent: 'Klasterio OCI podėlis (numatytasis): {name}',
    sectionOverview: 'Apžvalga',
    sectionRepositories: 'Repozitorijos',
    sectionExplore: 'Naršyti',
    exploreHint: 'Tiesioginė nuotolinė paieška registry — Docker Hub pilna (aprašymas, atsisiuntimai, žvaigždutės), kiti tiekėjai kiek įmanoma. Pasirinkite rezultatą, kad perskaitytumėte visą jo aprašymą ir peržiūrėtumėte nuotolines žymas; iš žymos galite pridėti nuorodą į TVirt repozitoriją.',
    exploreSearch: 'Ieškoti',
    exploreUnsupported: 'Šis tiekėjas paieškos nepalaiko.',
    exploreNoResult: 'Atitinkančių repozitorijų nerasta.',
    exploreNoTags: 'Šioje repozitorijoje atitinkančių žymų nerasta.',
    exploreOfficial: 'Oficialus',
    explorePulls: 'Atsisiuntimai',
    exploreStars: 'Žvaigždutės',
    exploreUpdated: 'Atnaujinta {when}',
    exploreLoadMore: 'Įkelti daugiau',
    exploreSelectHint: 'Pasirinkite rezultatą: visas aprašymas ir nuotolinės žymos įkeliami čia pat.',
    exploreNoDescription: 'Šis tiekėjas aprašymo nepateikia.',
    exploreTagsTitle: 'Nuotolinės žymos',
    exploreTagFilter: 'Ieškoti žymų',
    exploreAddToRepo: 'Pridėti į repozitoriją',
    exploreAdded: '{path}:{tag} nuo šiol sekamas — žr. skiltį Repozitorijos.',
    addBranch: 'Pridėti branch',
    purgeRequiredTitle: "Šalinti '{name}' su jo atvaizdžiais?",
    purgeRequiredBody: 'Jokia app šios repozitorijos nenaudoja, bet atsisiųstų atvaizdžių dar yra: šalinimas pašalina ir jų įrašus, o podėlio blob duomenys atitenka garbage collection.',
    purgeConfirm: 'Šalinti ir atvaizdžius',
    providerSelectHint: 'Pasirinkite registry tipą: kortelė pasakoja presetą ir paskirtį.',
    providerDesc: {
      dockerhub: 'Viešas Docker registry: URL užpildytas iš anksto, pilna paieška su aprašymais ir skaitikliais.',
      ghcr: 'GitHub Container Registry: URL užpildytas iš anksto; paskyros naudoja personal access token.',
      ecr: 'Amazon Elastic Container Registry: galiniai taškai kiekvienai paskyrai/regionui — URL būtina nurodyti.',
      quay: 'Red Hat Quay registry: URL užpildytas iš anksto.',
      generic: 'Savarankiškai talpinamas registry (Harbor, registry:2, …): https:// URL privalomas.'
    },

    // Standartinis dialogas (round #156): atvaizdžio ir registry išsamios
    // peržiūros laukai, kurių stulpeliai nerodė.
    layerCount: 'Sluoksniai',
    verifiedAt: 'Paskutinė patikra',
    verifyOk: 'Rezultatas',
    verifyMessage: 'Patikros pranešimas',

    // Modelis #348/R39: atvaizdas YRA digestas — turinys — o registry, saugykla ir šaka yra VARDAI, kurie jį pasiekia.
    head: 'Head',
    heads: 'Galvos pagal architektūrą',
    listDigest: 'Sąrašo digestas',
    neverResolved: 'Niekada neišspręsta',
    totalSize: 'Bendras dydis',
    reflogTitle: 'Išsprendimų istorija',
    usedBy: 'Naudoja',
    usageLockfile: 'lockfile',
    usageRunning: 'veikia',
    evictable: 'šalintinas',
    evict: 'Pašalinti iš podėlio',
    evictHeadTitle: 'Pašalinti {digest}?',
    evictHeadBody: 'Tai bent vieno kolektoriaus dabartinis išsprendimas: pašalinti jį teisėta — tai tik podėlis, nuotolinis branch jį vis dar teikia — bet tai neturi nutikti per klaidą. Blob yra VIENAS: šalinimas ištuština visus jį bendrinančius kolektorius.',
    evictConfirm: 'Vis tiek pašalinti',

    arch: 'Architektūra',
    names: 'Vardai',
    noNames: 'be vardo',
    views: 'Rodiniai',
    lastView: 'paskutinis rodinys',
    evictLastViewTitle: 'Pašalinti paskutinę nuorodą į {digest}?',
    evictLastViewBody: 'Tai paskutinis šio turinio rodinys: jį pašalinus atvaizdas nustoja egzistuoti TVirt sistemoje ir baitai ({size}) atlaisvinami. Tai modelio docker image rm — ne šalutinis poveikis, o pati operacija.',
    branchesTabHint: 'Stebimos šios saugyklos šakos: kiekvienai šiandienos galvos — po vieną kiekvienai architektūrai — atnaujinimų chronologija ir kiek jos įvardytų atvaizdų yra podėlyje. Atnaujinimas yra saugyklos «git fetch»: jis iš karto išsprendžia visas šakas.',
    noBranches: 'Šioje saugykloje nestebima nė viena šaka.',
    stopObserving: 'Nustoti stebėti šaką',
    pullBranch: 'Atsisiųsti į podėlį branch galvą (refresh išsprendžia, šis atsisiunčia)',
    pullDigest: 'Atsisiųsti į podėlį šį digest',
    imageCount: 'Atvaizdai',
    deleteBranchPurgeTitle: 'Palikti {name} atvaizdus be vardo?',
    deleteBranchPurgeBody: 'Nė viena programa neįvardija šios šakos, bet kai kuriuos atvaizdus pasiekia tik ji: ją ištrynus jie liks podėlyje be vardo, išvardyti tarp saugyklos atvaizdų ir šalinami rankomis.',
    deleteBranchPurgeConfirm: 'Ištrinti ir palikti atvaizdus be vardo',
    imagesTabHint: 'Šios saugyklos atvaizdai — turinys, tai yra digestai — matomi ir nepasirinkus šakos. Atvaizdas yra unikalus klasteryje: jį pasiekiančių vardų gali būti keli.',
    noImages: 'Nė vienas šios saugyklos atvaizdas nėra materializuotas podėlyje.',
    deleteRepositoryTitle: 'Ištrinti {name}?',
    deleteRepositoryBody: 'Saugykla ir jos šakos dingsta kartu su chronologija. Atvaizdai lieka podėlyje: jie praranda tik šį vardą. Saugyklos, kurią įvardija programa, ištrinti negalima.',
    provenanceCatalog: 'katalogas',
    refreshedAt: 'Atnaujinta',
    neverRefreshed: 'Niekada neatnaujinta',
    sectionBranches: 'Šakos',
    sectionImages: 'Atvaizdai',
    repositoriesGovernedElsewhere: 'Čia saugyklos tik peržiūrimos: jų registravimas, atnaujinimas, šakų stebėjimas ir atvaizdų šalinimas vyksta OCI atvaizdų skiltyje.',
    gotoImages: 'Eiti į OCI atvaizdus'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podai',
    containers: 'Konteineriai',
    instances: 'Egzemplioriai',
    instancesTooltip: '{running} veikia, {error} su klaida',
    placement: 'Išdėstymas',
    spread: 'paskirstymas',
    ha: 'HA',
    templateRevision: 'revizija',
    deleting: 'Šalinama',
    empty: 'Podų nėra — sukurkite programą (vieną konteinerį) arba podą iš CLI (create-pod).',
    openInstances: 'Atverti egzempliorius',
    rollingRestart: 'Laipsniškas paleidimas iš naujo',
    scale: 'Mastelis',
    scaleTitle: 'Keisti {name} mastelį',
    scaleHint: 'Egzempliorių skaičius (0–64): didinant užimamas žemiausias laisvas eilės numeris, mažinant pašalinamas aukščiausias, o jo nuolatiniai duomenys lieka.',
    scaleError: 'Mastelio keitimas nepavyko',
    replicas: 'Replikos',
    deleteRunningError: '{name} veikia — pirmiausia sustabdykite.',
    deleteInstancesIntro: 'Bus pašalinti visi {count} egzemplioriai.',
    stateRunning: 'Veikia',
    stateStopped: 'Sustabdyta',
    editor: {
      createTitle: 'Sukurti Pod',
      create: 'Sukurti Pod',
      editTitle: 'Redaguoti Pod',
      nameHint: 'DNS-1123, ne daugiau kaip 58 simboliai — egzemplioriai vadinami <vardas>-<indeksas>; nekeičiama po sukūrimo.',
      restartPolicy: 'Paleidimo iš naujo politika',
      restartPolicyHint_always: 'Mazgas iš naujo paleidžia kiekvieną pasibaigusį konteinerį su eksponentiniu laukimu (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Iš naujo paleidžiamas tik konteineris, pasibaigęs nenuliniu kodu; išėjimas 0 lieka ramybėje.',
      restartPolicyHint_never: 'Pasibaigęs konteineris paliekamas koks yra — egzempliorius baigiasi kaip succeeded arba failed.',
      grace: 'Atidėjimas (s)',
      graceHint: 'Sustabdymo riba SIGTERM → SIGKILL.',
      hostname: 'Pagrindinio kompiuterio vardas',
      hostnameHint: 'Tuščia = egzemplioriaus vardas.',
      hostnameDefault: 'egzemplioriaus vardas',
      sharePid: 'Bendrinti PID vardų erdvę tarp konteinerių',
      containersIntro: 'Init konteineriai vykdomi iki galo, iš eilės, prieš paleidžiant konteinerius; konteineriai dalijasi egzemplioriaus tinklu (vienas IP, localhost tarpusavyje).',
      initContainers: 'Init konteineriai',
      initAdd: 'Pridėti init konteinerį',
      initHint: 'Kiekvienas turi baigtis 0; nesėkmė perkelia egzempliorių į klaidą, o mazgas bando iš naujo su laukimu.',
      containerAdd: 'Pridėti konteinerį',
      atLeastOne: 'Pod reikia bent vieno konteinerio.',
      duplicateNames: 'Konteinerių vardai Pod viduje turi būti unikalūs (įskaitant init konteinerius).',
      containerName: 'Konteinerio vardas',
      containerInvalid: 'Šis konteineris neužbaigtas: vardas (DNS-1123), atvaizdas, prijungimai prie deklaruotų tomų, skaitinės ribos ir zondas.',
      command: 'Komanda',
      commandHint: 'Pakeičia atvaizdo entrypoint — po vieną argumentą eilutėje, niekada ne apvalkalo eilutė.',
      args: 'Argumentai',
      argsHint: 'Po vieną eilutėje (atvaizdo CMD, jei tuščia).',
      mounts: 'Prijungimai',
      mountAdd: 'Pridėti prijungimą',
      mountNoVolumes: 'Pirmiausia deklaruokite tomą skirtuke Saugykla.',
      readOnly: 'tik skaitymui',
      resources: 'Ribos',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (pvz., 1.5)',
      memory: 'Atmintis (MiB)',
      memoryHint: 'podman --memory',
      health: 'Gyvybingumo zondas',
      healthCmd: 'Zondo komanda',
      healthCmdHint: 'Mazgas vykdo ją konteinerio viduje kiekvieną priežiūros taktą — po vieną argumentą eilutėje; išėjimas 0 = sveikas.',
      healthTimeout: 'Laiko limitas (s)',
      healthRetries: 'Bandymai',
      healthRetriesHint: 'Nesėkmės iš eilės, kol mazgas iš naujo paleis konteinerį.',
      ips: 'Statiniai adresai',
      ipsHint: 'Po vieną egzemplioriui, eilės numerių tvarka — mastelis už sąrašo ribų atmetamas.',
      instance: 'egzempliorius',
      volumesHint: 'Tomai priklauso Pod; prijungimo kelias — kiekvienam konteineriui (skirtukas Konteineriai).',
      spread: 'Paskirstymas',
      spreadHint_preferred: 'Egzemplioriai skirtinguose mazguose, kai įmanoma.',
      spreadHint_required: 'Egzemplioriai skirtinguose mazguose, kitaip mastelio keitimas atmetamas.',
      spreadHint_none: 'Tik sprendėjas.',
      ha: 'Aukštas pasiekiamumas (opt-in)',
      haHint: 'Kiekviena nuolatinė dalis bendroje saugykloje; jei mazgas miršta, HA decider egzempliorius sukuria iš naujo kitame naryje (automatinis failover, kaip HA VM).',
      yes: 'taip',
      no: 'ne'
    },
    detail: {
      container: 'Konteineris',
      actions: 'Veiksmai',
      ready: 'Paruoštas',
      notReady: 'Neparuoštas',
      restarts: 'Paleidimai iš naujo',
      lastRestartAt: 'Paskutinis paleidimas iš naujo:',
      backoffUntil: 'Bandymas iš naujo',
      stateAbsent: 'nėra',
      stateRunning: 'veikia',
      stateTerminated: 'baigtas',
      stateWaiting: 'laukia',
      init: 'init',
      noInstances: 'Nėra egzempliorių (replikų 0).',
      ha: 'HA',
      haHint: 'Automatinis failover: jei mazgas miršta, HA decider egzempliorių sukuria iš naujo kitame naryje (kiekviena nuolatinė dalis bendroje saugykloje).',
      authority: 'Authority (mazgas)',
      homeless: 'be authority',
      homelessHint: 'Atkūrimas iš checkpoint palieka authority nuošalyje (#380): joks mazgas jo neaptarnauja, kol nepakeisite Pod mastelio (kad ir iki to paties replikų skaičiaus).',
      restartContainer: 'Iš naujo paleisti tik šį konteinerį (pod lieka veikti)',
      divergingHint: 'Šio egzemplioriaus norima būsena skiriasi nuo Pod numatytosios (PD-P19).',
      revisionLag: 'pritaikyta revizija {applied} iš {current}',
      updatedInstances: '{updated}/{desired} egzempliorių šioje revizijoje'
    }
  }
}
